import clsx from "clsx";
import { Slider as SliderPrimitive } from "radix-ui";
import React from "react";
import styles from "./slider.module.scss";

export type SliderProps = React.ComponentPropsWithoutRef<
  typeof SliderPrimitive.Root
>;

export const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, ...props }, ref) => {
  const values = props.value ?? props.defaultValue ?? [0];

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={clsx(styles.root, className)}
      {...props}
    >
      <SliderPrimitive.Track className={styles.track}>
        <SliderPrimitive.Range className={styles.range} />
      </SliderPrimitive.Track>
      {/* Render a thumb for each value. We use a manual loop here to satisfy 
          linting rules; the index is stable as slider thumbs do not reorder. */}
      {(() => {
        const thumbs = [];
        for (let i = 0; i < values.length; i++) {
          thumbs.push(
            <SliderPrimitive.Thumb
              key={`thumb-${i}`}
              className={styles.thumb}
            />
          );
        }
        return thumbs;
      })()}
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;
